const DROPDOWN_KEY = /* @__PURE__ */ Symbol("DROPDOWN_KEY");
export {
  DROPDOWN_KEY
};
//# sourceMappingURL=type.js.map
